<template>
  <div class="unit-input">
    <div class="addon" v-show="displayValue">
      <span class="hidden">{{ displayValue }}</span>
      <span class="unit-mark">{{ mark }}</span>
    </div>
    <input type="number" class="input" :placeholder="placeholder" :value="displayValue" @input="onInput"
      @change="onChange">
  </div>
</template>

<script>
export default {
  props: {
    mark: String,
    value: Number,
    placeholder: String
  },
  data() {
    return {
      keepClean: false,
      valueCopy: String(this.value)
    }
  },
  computed: {
    displayValue() {
      if (!this.keepClean) {
        this.valueCopy = String(this.value)
      }
      return this.valueCopy
    }
  },
  methods: {
    onInput(event) {
      this.valueCopy = event.target.value
      if (/^0+/.test(this.valueCopy) || /\./.test(this.valueCopy)) {
        this.valueCopy = Math.round(this.valueCopy)
        event.target.value = this.valueCopy
      }
      this.keepClean = this.valueCopy === ''
      this.$emit('input', Number(this.valueCopy))
    },
    onChange(event) {
      this.keepClean = false
      this.valueCopy = event.target.value
      if (this.valueCopy === '') {
        this.valueCopy = '0'
        event.target.value = '0'
      }
      this.$emit('change', Number(this.valueCopy))
    }
  }
}
</script>

<style lang="postcss" scoped>
.unit-input {
  position: relative;
  height: 45px;
  border: solid 2px #aeaeae;
}

.input {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0 0 0 1em;
  line-height: 41px;
}

.addon {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0 0 0 1em;
  line-height: 41px;
  overflow: hidden;
  pointer-events: none;
}

.hidden {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// UnitInput.vue?2eeda7ea